import React from 'react';
import {connect} from 'react-redux';
import NumberHelper from 'helpers/number-helper';
import BaseTeamDetails from '../base-team-details';

class TeamDetails extends BaseTeamDetails {
    render() {
        const totalValue = this.getImpliedTeamTotalValue();
        return (
            <span className="spread-text">
                Spread: <strong>{NumberHelper.float(totalValue, 3)}</strong>
            </span>
        );
    }
}

function mapStatesToProps(state) {
    const {
        playersData: {teams},
    } = state;
    return {
        teams: teams.all(),
    };
}

const TeamDetailsComponent = connect(mapStatesToProps)(TeamDetails);

export {TeamDetailsComponent};
